import { type InputHTMLAttributes, forwardRef } from 'react';

interface MysticInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

/**
 * Fantasy-styled input with floating label
 */
export const MysticInput = forwardRef<HTMLInputElement, MysticInputProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className="relative">
        <input
          ref={ref}
          className={`
            peer w-full px-4 py-3 bg-void/80 border border-stone/50 rounded-lg
            text-parchment placeholder-transparent
            focus:outline-none focus:border-rune focus:ring-1 focus:ring-rune/30
            disabled:opacity-50 disabled:cursor-not-allowed
            transition-colors duration-200
            ${error ? 'border-ember/70 focus:border-ember focus:ring-ember/30' : ''}
            ${className}
          `}
          placeholder={label}
          {...props}
        />
        <label
          className={`
            absolute left-4 -top-2.5 px-1 bg-night text-xs
            text-mist peer-focus:text-rune
            peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:bg-transparent
            transition-all duration-200 pointer-events-none
            ${error ? 'text-ember peer-focus:text-ember' : ''}
          `}
        >
          {label}
        </label>
        {error && <p className="mt-1 text-xs text-ember">{error}</p>}
      </div>
    );
  },
);

MysticInput.displayName = 'MysticInput';
